import {Component} from '@angular/core';
import {TodoSettingsStatus} from './components/todo-settings-status/todo-settings-status';
import {TranslateModule} from '@ngx-translate/core';
import {ElciaCard} from '../../../../components/card/card';

@Component({
  selector: 'elcia-todo-settings',
  imports: [
    TodoSettingsStatus,
    TranslateModule,
    ElciaCard
  ],
  providers: [],
  templateUrl: './todo-settings.html',
  styleUrl: './todo-settings.scss',
})

export class TodoSettings {
}
